import Axios from 'axios';

const MY_TUTORS_RESSOURCE = '/my_dorm/tutoren'
const MY_TUTORS_ASSIGN_RESSOURCE = '/my_dorm/tutoren/assign'
const MY_TUTORS_DELETE_RESSOURCE = '/my_dorm/tutoren/delete'
const MY_TUTORS_DISCHARGE_RESSOURCE = '/my_dorm/tutoren/discharge'
const MY_DORM_RESSOURCE = '/my_dorm'
const MY_DORM_TENANTS = '/my_dorm/find_tenant'
const MY_DORM_AEMTER = '/my_dorm/aemter'
const MY_DORM_ADVANCE_SEMESTER = '/my_dorm/advance_semester'
const MY_DORM_COMMON_ROOMS = '/my_dorm/common_rooms'
const ALL_DORMS = '/public/dorms';
const ALERTS = '/public/alerts';

export default {
    getAllDorms() {
        return Axios.get(ALL_DORMS);
    },
    getAlerts() {
        return Axios.get(ALERTS+'?'+ Math.random());
    },
    getMyDorm() {
        return Axios.get(MY_DORM_RESSOURCE)
    },
    getMyTutors(semester) {
        return Axios.get(MY_TUTORS_RESSOURCE+'?semester='+semester)
    },
    findTenants(term) {
        return Axios.get(MY_DORM_TENANTS+'?name_or_room='+term)
    },
    getAemter() {
        return Axios.get(MY_DORM_AEMTER)
    },
    assignTutor(bwid, amtid, semesterid) {
        return Axios.post(MY_TUTORS_ASSIGN_RESSOURCE, {amt:amtid, bewohner: bwid, semester: semesterid})
    },
    deleteTutor(tutid) {
        return Axios.post(MY_TUTORS_DELETE_RESSOURCE, {tutor:tutid})
    },
    dischargeTutor(tutid) {
        return Axios.post(MY_TUTORS_DISCHARGE_RESSOURCE, {tutor:tutid})
    },
    advanceSemsester(semid) {
        return Axios.post(MY_DORM_ADVANCE_SEMESTER, {semester:semid})
    },
    getCommonRooms() {
        return Axios.get(MY_DORM_COMMON_ROOMS)
    }
}
